// * app => node => python
export enum ToPythonRoutes {
  BuildHits = 'build-hits',
}
